// Collapse a Loox widget's section while the widget has nothing to show (no real reviews yet), and
// reveal it as soon as Loox grows its iframe. CSS alone cannot see an iframe's rendered height.
// The section is collapsed with height 0 rather than display:none so the iframe keeps its layout
// width and Loox can still size it.
(() => {
  const update = (section) => {
    const frames = section.querySelectorAll('.loox-widget iframe');
    const empty = frames.length > 0 && [...frames].every((f) => f.getBoundingClientRect().height < 2);
    section.toggleAttribute('data-pt-loox-empty', empty);
  };
  const watch = () => {
    document.querySelectorAll('.loox-widget').forEach((widget) => {
      const section = widget.closest('.shopify-section');
      if (!section || section.dataset.ptLooxWatched) return;
      section.dataset.ptLooxWatched = 'true';
      const observer = new ResizeObserver(() => update(section));
      widget.querySelectorAll('iframe').forEach((f) => observer.observe(f));
      new MutationObserver(() => {
        widget.querySelectorAll('iframe').forEach((f) => observer.observe(f));
        update(section);
      }).observe(widget, { childList: true, subtree: true });
      update(section);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
